/**
 * Translation utilities for item types and categories
 */

export const itemTypeTranslations = {
  company: 'Azienda',
  worker: 'Lavoratore',
  vehicle: 'Veicolo',
  equipment: 'Attrezzatura',
  chemical: 'Prodotto Chimico',
};

export const getItemTypeLabel = (itemType) => {
  return itemTypeTranslations[itemType] || itemType;
};

export const getTranslatedItemTypes = () => {
  return Object.entries(itemTypeTranslations).map(([value, label]) => ({
    value,
    label,
  }));
};
